import React from "react";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";

import DemoFooter from "components/Footers/DemoFooter.js";

const Projects = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  return (
    <>
      <div className="about-us section" style={{backgroundColor:"#3e3c3d"}}>
        <div
          style={{
            //backgroundImage: "url(" + require("assets/img/bg.png") + ")",
            backgroundColor:"#3E3C3D",
            
          }}
          className="page-bg"
        >
          <ExamplesNavbar notHome={true} />
          {/* <div className="section about-us"> */}
          <Container>
            <Row>
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/resplot/res1.png") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
                <br></br>
                <h3 className="title text-white ">Art of living  <hr style={{color:"#000000"}}/></h3>
                
                
                <div className="detail text-white">
                
                  Meraj Housing society is a project owned<br/> by the Directors of
                  Virk Group of<br/> Industries, which has developed its name<br/> in the
                  filed of manufacturing and <br/>customer service since 1995.
                </div>
              </Col>
            </Row>

            <Row className="my-5" >
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/resplot/res2.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
              <h3 className="title  text-white">
              <br/> 5 MARLA <hr/></h3>
                 
                <div className="detail text-white">
                (25*45) Sq.Ft
                <br></br>
                <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                </div>
              </Col>
            </Row>

            <Row className="my-6" >
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/resplot/res3.jpg") + ")",
                    backgroundColor:"#3E3C3D"
                }}
                className="about-image"
              />
              <Col lg={6}>
                <div className="detail text-white" >
                  <h3><br/>10 MARLA  <hr/></h3>
                  (37.5*60) Sq.Ft
                  <br></br>
                <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                
                </div>
              </Col>
              
            </Row>

            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/resplot/res4.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h4><br/>1 KANAL <hr/></h4>
                (50*90)Sq.Ft
                
                </div>

              </Col>
            </Row>
           
            
           
            
          </Container>
          {/* </div> */}
          <div
          className={"footer-logo-section content-center"}style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image"
            src={require("assets/img/logo@2x.png")}
          />
          
        </div>
         
          { <DemoFooter/> }
        </div>
      </div>
    </>
  );
};

export default Projects;
